var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AttachmentSelector from '@/Common/components/AttachmentSelector.vue';
import DatePicker from '@common/vuejs/components/DatePicker.vue';
import DisplayValidationCollector from '@common/vuejs/components/DisplayValidationCollector.vue';
import Loader from '@common/vuejs/components/Loader.vue';
import { isNullOrUndefined } from 'util';
import { Component, Vue } from 'vue-property-decorator';
import { ACTION_TYPE } from '../store/types/actionType';
var MachineRegistrationCreationComponent = /** @class */ (function (_super) {
    __extends(MachineRegistrationCreationComponent, _super);
    function MachineRegistrationCreationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MachineRegistrationCreationComponent.prototype.machine = function () {
        return this.$store.state.registration;
    };
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "registration", {
        get: function () {
            return this.machine();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "submitButtonText", {
        get: function () {
            if (isNullOrUndefined(this.machine()))
                return "";
            var length = this.machine().machineRegistrations.length;
            if (length == 1)
                return "Submit (" + length + ") registration";
            return "Submit (" + length + ") registrations";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "hasRegistrations", {
        get: function () {
            if (isNullOrUndefined(this.machine()))
                return false;
            var length = this.machine().machineRegistrations.length;
            return length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isLoading", {
        get: function () {
            return this.$store.state.isInitializing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "validationCollector", {
        get: function () {
            return this.$store.state.validationCollector;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "allowedMimeTypes", {
        get: function () {
            var _a;
            return (_a = this.$store.state.initializationData) === null || _a === void 0 ? void 0 : _a.allowedMimeTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "maxTotalFileSizeInBytes", {
        get: function () {
            var _a;
            return (_a = this.$store.state.initializationData) === null || _a === void 0 ? void 0 : _a.maxTotalFileSizeInBytes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "siteKey", {
        get: function () {
            var _a;
            return (_a = this.$store.state.initializationData) === null || _a === void 0 ? void 0 : _a.siteKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isLoadingMachineInformation", {
        get: function () {
            return this.$store.state.isLoadingMachineInformation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isMachineModelDisabled", {
        get: function () {
            var _a, _b;
            if (this.isLoadingMachineInformation)
                return true;
            if (!isNullOrUndefined((_b = (_a = this.registration) === null || _a === void 0 ? void 0 : _a.machineInformation) === null || _b === void 0 ? void 0 : _b.unitDescription))
                return true;
            return false;
        },
        enumerable: true,
        configurable: true
    });
    MachineRegistrationCreationComponent.prototype.loadMachineInformation = function () {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.isLoadingMachineInformation)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.$store.dispatch(ACTION_TYPE.LoadMachineInformation)];
                    case 1:
                        _c.sent();
                        if (isNullOrUndefined((_b = (_a = this.registration) === null || _a === void 0 ? void 0 : _a.machineInformation) === null || _b === void 0 ? void 0 : _b.unitDescription))
                            return [2 /*return*/];
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "unitDescription", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.$store.state.registration) === null || _a === void 0 ? void 0 : _a.machineInformation) === null || _b === void 0 ? void 0 : _b.unitDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isInstalledSmartLink", {
        get: function () {
            return this.boolToString(this.machine().machineRegistrationData.isInstalledSmartLink);
        },
        set: function (value) {
            if (isNullOrUndefined(this.machine()))
                return;
            var boolValue = this.isStringTrue(value);
            if (!boolValue)
                this.machine().machineRegistrationData.isActivatedSmartLink = false;
            this.machine().machineRegistrationData.isInstalledSmartLink = boolValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isActivatedSmartLink", {
        get: function () {
            return this.boolToString(this.machine().machineRegistrationData.isActivatedSmartLink);
        },
        set: function (value) {
            if (isNullOrUndefined(this.machine()))
                return;
            var boolValue = this.isStringTrue(value);
            if (!boolValue)
                this.machine().machineRegistrationData.serialNumberSmartLink = null;
            if (!boolValue)
                this.machine().machineRegistrationData.imeiSmartLink = null;
            if (!boolValue)
                this.machine().machineRegistrationData.startUpDate = null;
            this.machine().machineRegistrationData.isActivatedSmartLink = boolValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "serialNumberSmartLink", {
        get: function () {
            return this.machine().machineRegistrationData.serialNumberSmartLink;
        },
        set: function (value) {
            if (isNullOrUndefined(this.machine()))
                return;
            this.machine().machineRegistrationData.serialNumberSmartLink = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "imeiSmartLink", {
        get: function () {
            return this.machine().machineRegistrationData.imeiSmartLink;
        },
        set: function (value) {
            if (isNullOrUndefined(this.machine()))
                return;
            this.machine().machineRegistrationData.imeiSmartLink = value;
        },
        enumerable: true,
        configurable: true
    });
    MachineRegistrationCreationComponent.prototype.isStringTrue = function (value) {
        return (value === 'true');
    };
    MachineRegistrationCreationComponent.prototype.boolToString = function (value) {
        if (isNullOrUndefined(value))
            return 'false';
        return (value) ? 'true' : 'false';
    };
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isCreating", {
        get: function () {
            return this.$store.state.isCreating;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isAdding", {
        get: function () {
            return this.$store.state.isAdding;
        },
        enumerable: true,
        configurable: true
    });
    MachineRegistrationCreationComponent.prototype.tempAttachmentId = function () {
        return this.$store.state.newAttachmentId;
    };
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "hasPartialSubmits", {
        get: function () {
            return !isNullOrUndefined(this.tempAttachmentId());
        },
        enumerable: true,
        configurable: true
    });
    MachineRegistrationCreationComponent.prototype.submit = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.isLoading || this.isCreating)
                    return [2 /*return*/];
                this.$store.state.registration.recaptchaResponse = $("#g-recaptcha-response").val();
                this.$store.dispatch(ACTION_TYPE.CreateMachineRegistration).then(function () {
                    window.grecaptcha.reset();
                });
                return [2 /*return*/];
            });
        });
    };
    MachineRegistrationCreationComponent.prototype.partialSubmit = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.isLoading || this.isCreating)
                    return [2 /*return*/];
                this.$store.dispatch(ACTION_TYPE.ValidateAndAddAttachment);
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(MachineRegistrationCreationComponent.prototype, "isAirTube", {
        get: function () {
            var _a;
            return (_a = this.$store.state.initializationData.isAirTube) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: true,
        configurable: true
    });
    MachineRegistrationCreationComponent.prototype.mounted = function () {
        var _this = this;
        this.$store.subscribeAction(function (action) {
            if (action.type == ACTION_TYPE.Reset) {
                _this.$notify({
                    title: 'Thank you!',
                    text: 'A mail has been sent to you.<br /> In order to complete the machine registrations, please click the confirmation links.',
                    type: 'success',
                    duration: 30000
                });
            }
            if (action.type == ACTION_TYPE.ResetMachine) {
                _this.$notify({
                    title: 'Thank you!',
                    text: 'Your registration was added. <br> Do not forget to click submit to complete the process.',
                    type: 'warn',
                    duration: 10000
                });
            }
        });
    };
    MachineRegistrationCreationComponent = __decorate([
        Component({
            name: 'machine-registration-creation',
            components: {
                Loader: Loader,
                DisplayValidationCollector: DisplayValidationCollector,
                DatePicker: DatePicker,
                AttachmentSelector: AttachmentSelector,
            }
        })
    ], MachineRegistrationCreationComponent);
    return MachineRegistrationCreationComponent;
}(Vue));
export default MachineRegistrationCreationComponent;
